/**
 * Layout component for authentication routes
 * Part of the FAANG-grade _app.tsx refactoring - Phase 4.1
 *
 * Used for routes that don't require authentication or full app layout:
 * - /login, /register, /auth/*
 * - /logout
 * - Test routes like /form-test, /test-js
 * - Week 11 public routes (/pwa/*, /crm/pipeline, /services, /quotes)
 */

import Head from 'next/head';
import React from 'react';

import type { ProviderProps } from '../../types/app';
import PrecacheRoutes from '../PrecacheRoutes';

/**
 * Simplified layout for authentication and public routes
 * Does not include navigation, tenant context, or protected route guards
 */
export const AuthLayout: React.FC<ProviderProps> = ({ children }) => {
  return (
    <>
      <Head>
        <meta name="viewport" content="width=device-width, initial-scale=1, maximum-scale=1" />
      </Head>
      <PrecacheRoutes />
      {children}
    </>
  );
};